module.exports = __webpack_public_path__ + "img/100.cfd50e19.svg";